import { Grid } from '@mui/material';
import { Control, Controller, UseFormGetValues } from 'react-hook-form';
import { NumberInputWidget } from 'src/components/widget/numberInputWidget/NumberInputWidget';
import { SelectDropdownWidget } from 'src/components/widget/selectDropdownWidget/SelectDropdownWidget';
import { isDy } from 'src/features/components/editComponentPage/EditComponentPage.helper';
import { handleComponentConfigChange } from 'src/utils/changeHandler';
import { lang } from 'src/utils/language';

import {
  CommonFormProps,
  ShelfProductTextAlignmentEnum,
} from '../../../FormSelector.interface';
import { ISingleShelfConfig } from '../../SingleShelf.interface';

interface TextAlignmentFormProps {
  control: Control<ISingleShelfConfig, any>;
  props: CommonFormProps;
  getValues: UseFormGetValues<ISingleShelfConfig>;
}

export const TextAlignmentForm = ({
  control,
  props,
  getValues,
}: TextAlignmentFormProps) => {
  const textAlignment = getValues('lineupStyle.textAlignment');

  const isDyProductSource = isDy(
    props?.componentDetails?.config?.productsSource,
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={!!textAlignment ? 6 : 12}>
        <Controller
          name="lineupStyle.textAlignment"
          control={control}
          render={({ field: { ref, ...field }, fieldState }) => (
            <SelectDropdownWidget
              {...field}
              ref={ref}
              hasError={!!fieldState.error}
              error={fieldState.error?.message || false}
              label={lang.alignment}
              disabled={isDyProductSource}
              value={
                isDyProductSource
                  ? ShelfProductTextAlignmentEnum.CENTER
                  : textAlignment
              }
              selectOptions={[
                { label: 'Left', value: 'LEFT' },
                { label: 'Right', value: 'RIGHT' },
                { label: 'Center', value: 'CENTER' },
              ]}
              onChange={(value) => {
                handleComponentConfigChange(
                  props,
                  `lineupStyle`,
                  {
                    ...getValues('lineupStyle'),
                    textAlignment: value,
                    padding: 0,
                  },
                  field.onChange,
                );
              }}
            />
          )}
        />
      </Grid>

      {!!textAlignment && (
        <Grid item xs={6} key={textAlignment}>
          <Controller
            name={`lineupStyle.padding`}
            control={control}
            render={({ field: { ref, ...field }, fieldState }) => (
              <NumberInputWidget
                {...field}
                ref={ref}
                label={lang.padding}
                hasError={!!fieldState.error}
                error={fieldState.error?.message || false}
                value={
                  textAlignment === ShelfProductTextAlignmentEnum.CENTER ||
                  isDyProductSource
                    ? ''
                    : field.value || 0
                }
                onChange={(value) =>
                  handleComponentConfigChange(
                    props,
                    `lineupStyle.padding`,
                    value,
                    field.onChange,
                  )
                }
                disabled={
                  isDyProductSource ||
                  textAlignment === ShelfProductTextAlignmentEnum.CENTER
                }
                options={{
                  min: 0,
                }}
              />
            )}
          />
        </Grid>
      )}
    </Grid>
  );
};
